import { KatDatePicker } from '@amzn/katal-react';
import { RJSFSchema, UiSchema, WidgetProps } from '@rjsf/utils';
import React from 'react';

import DatePicker from 'src/react-jsonschema-katal/katal/components/DatePicker';
import { DATE_DISABLED_FUNCTIONS } from 'src/react-jsonschema-katal/katal/components/DatePicker/DatePickerHelper';
import { TextViewWidget } from '../components/ViewWidget';
/**
 * Check the date picker function options.
 * @param uiSchema uiSchema
 * @returns boolean
 */
const getDateDisabledFunction = (
  uiSchema: UiSchema<any, RJSFSchema, any> | undefined,
): DATE_DISABLED_FUNCTIONS => {
  return (
    (uiSchema?.['ui:dateDisabledFunction'] as DATE_DISABLED_FUNCTIONS) ||
    DATE_DISABLED_FUNCTIONS.DATE_LESS_THAN_TODAY
  );
};

const DatePickerWidget: React.FC<WidgetProps> = ({
  label,
  value,
  onChange,
  disabled,
  required,
  uiSchema,
  rawErrors,
}) => {
  if (disabled) {
    return <TextViewWidget label={label} value={value} />;
  }

  const additionalErrorProps: KatDatePicker._OwnProps = {};
  if (rawErrors && rawErrors.length > 0) {
    additionalErrorProps.state = 'error';
    additionalErrorProps.stateLabel = rawErrors
      .filter((error, index) => rawErrors.indexOf(error) === index)
      .join(',');
  }

  return (
    <DatePicker
      label={label}
      onDateSelected={onChange}
      value={value}
      disabled={disabled}
      required={required}
      dateDisabledFunction={getDateDisabledFunction(uiSchema)}
      {...additionalErrorProps}
    />
  );
};

export default DatePickerWidget;
